module.exports = __webpack_public_path__ + "img/hbtck2@2x.813d074a.png";